import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';

import { distinctUntilChanged, filter, map, of, switchMap, take, tap } from 'rxjs';
import { VrcAuthService } from './vrc-auth.service';
import { VrcDataService } from './vrc-data.service';
import { VrcBrowserStorageService } from './vrc-browser-storage.service';

export const vrcAuthInitGuard: CanActivateFn =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const _auth = inject(VrcAuthService);
    const _srvc = inject(VrcDataService);
    const _bst = inject(VrcBrowserStorageService);
    if (_auth.msalIsInitiazed) {
      if (_bst.subscription === null) {
        return _srvc.getSubscription().pipe(
          take(1),
          map(x => {
            _bst.subscription = x;
            return true;
          }))
      }
      return true;
    }
    return _auth.msalIsInitiazedObservable.pipe(
      filter(x => x == true),
      switchMap(x => {
        if (_bst.subscription === null || _bst.subscription==="null") {
          return _srvc.getSubscription().pipe(
            take(1),
            map(x => {
              _bst.subscription = x;
              return true;
            }))
        }
        return of(x);
      }),
      distinctUntilChanged()
    );
  };
